module.exports = __webpack_public_path__ + "static/media/ico-remove.77749fcd.svg";